<template>
  <Modal class-name="vertical-center-modal" v-model="isDetail" title="餐品信息">
    <div class="form-wrapper">
      <div class="pay-price">支付金额: <span> ￥{{ payPrice }}</span></div>
      <Table border
             :columns="columns"
             :data="list"
             :loading="loading">
      </Table>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="handelSure">确定</span>
      </div>
    </div>
  </Modal>
</template>

<script>
  import { Modal, Table } from 'view-design'
  import order from '@/javaApi/kfc/order'
  const orderModel = new order()
  export default {
    name: "Detail",
    components: { Modal, Table },
    props: {},
    created() {},
    data: function () {
      return {
        isDetail: false,
        loading:false,
        payPrice: '0.00',
        columns: [
          {
            title: '商品名称',
            key: 'goods_info',
            width: 250,
            align: 'center',
            render: (h, params) => {
              let name = params.row.name
              let imageUrl = params.row.imageUrl
              let renderData = []
              if(imageUrl) {
                renderData.push(
                  h('img',{
                    attrs:{
                      src: imageUrl, style: 'width: 30%;height: auto;margin:15px;float:left;cursor:pointer;'
                    },
                  })
                )
              }
              renderData.push(
                h('div', {
                  attrs: {
                    style: 'font-family: Alibaba-PuHuiTi-R;font-size: 14px;color: #666666;text-align: left;'
                  }
                }, name)
              )
              return h('div',
                {
                  attrs: {
                    style: 'display: flex; align-items: center;'
                  }
                }, renderData);
            }
          },
          {
            title: '数量',
            key: 'number',
            width: 114,
            align: 'center',
          },
          {
            title: '金额',
            key: 'price_info',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let price = params.row.salePrice;
              let oldPrice = params.row.showPrice;
              const str = params.row.statusStr.replace(/\s+/g,"");
              if(str !== ''){
                price += `（${params.row.statusStr}）`;
              }
              let renderData = []
              renderData.push(h('div',{
                attrs: {
                  style:'font-family: Alibaba-PuHuiTi-R;font-size: 14px;color: #666666;'
                }
              },price))
              renderData.push(h('div',{
                attrs: {
                  style:'font-family: PingFangSC-Regular;font-size: 12px;color: #999999;text-decoration:line-through;'
                }
              },oldPrice))
              return renderData
            }
          }
        ],
        list:[],
      }
    },
    methods: {
      init: function (row) {
        this.isDetail = true
        this.loading = true
        const param = {
          orderNumber: row.orderNumber
        }
        orderModel.getOrderInfo(param).then((response) => {
          var res = response.data
          this.loading = false
          if(!res.success){
            this.$Message.error(res.message)
            return
          }
          this.list = res.data.orderInfo
          this.payPrice = res.data.payPrice
        })
      },
      handelCancel: function () {
        this.isDetail = false
      },
      handelSure: function () {
        this.handelCancel();
      }
    }
  }
</script>

<style scoped>
 .pay-price{
   font-family: Alibaba-PuHuiTi-R;
   font-size: 14px;
   color: #666666;
   margin-bottom: 20px;
 }
 .pay-price span{
   font-family: Alibaba-PuHuiTi-M;
   font-size: 18px;
   color: #222222;
   margin-left: 10px;
 }
  >>> .ivu-modal-body {
    padding: 16px 16px 0px 16px;
  }
  >>> .ivu-modal-content{
    border-radius: 0;
  }
  >>> .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  >>> .vertical-center-modal .ivu-modal {
    top: 0;
  }
  >>> .vertical-center-modal .ivu-modal-footer {
    border-top: none;
    padding: 40px 18px;
    text-align: right;
  }
  .footer-wrapper {
    display: flex;
    min-width: 0;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  .footer-wrapper .btn {
    display: inline-block;
    border-radius: 2px;
    margin-right: 10px;
    padding: 0px 20px;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    vertical-align: middle;
    cursor: pointer;
  }
  .footer-wrapper .btn.confirm-btn {
    background: #D63036;
    color: #fff;
  }
  .footer-wrapper .btn.cancel-btn {
    border: 1px solid #eeeeee;
    border-radius: 2px;
    color: #222222;
  }
  >>> .ivu-modal-footer {
    border-top: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/kfc/TicketDetail.vue